import {
  __,
  contains,
  path,
  prop,
  mergeAll,
  map,
  split,
  dropLast,
  match,
  join,
  compose,
  curry,
  test,
  propOr,
} from 'ramda';
import { generatePath } from 'react-router';

import setupRoute from '../../helpers/routes/setup';
import { getLang } from '../../helpers/i18n';
import { extractColdPageUids } from '../../helpers/routes/cold-page';
import { findRouteThatMatchForRoutes } from '../../helpers/routes/utils';

import ROUTE from './route';
import COLD_PAGE from './cold-page';

const { ROUTE_KEY, ROUTES, PATH_TO_ROUTE, ROUTE_TO_PATH } = setupRoute(
  COLD_PAGE,
  ROUTE
);

const COLD_PAGE_UIDS = extractColdPageUids(COLD_PAGE);
const isColdPage = contains(__, COLD_PAGE_UIDS);

const extractDefaultParams = compose(
  mergeAll,
  map(
    compose(
      ([, key, value]) => key && { [key]: value },
      match(/^:([\w_-]+)(?:\(([\w_-]+)\))?\??/)
    )
  ),
  split('/')
);

const getPathForRouteKey = (routeKey, lng) =>
  path([routeKey, lng], ROUTE_TO_PATH);

const getUrlForRouteKey = (routeKey, lng, params = {}) => {
  const lang = getLang(lng);
  const path = getPathForRouteKey(routeKey, lang);
  if (path) {
    return generatePath(path, {
      ...extractDefaultParams(path),
      ...params,
      lng: lang,
    });
  }
};

const getRouteKeyForPath = prop(__, PATH_TO_ROUTE);

const findRouteThatMatch = findRouteThatMatchForRoutes(ROUTES);

const getParentOfRouteKey = compose(join('__'), dropLast(1), split('__'));

const appendChildKey = curry((childKey, routeKey) => {
  if (!test(new RegExp(`/__${childKey}$/`), routeKey)) {
    return `${routeKey}__${childKey}`;
  }
  return routeKey;
});

const getRouteKeyOfChild = (defaultRouteKey, childKey, routeKey) =>
  compose(
    propOr(appendChildKey(childKey, defaultRouteKey), __, ROUTE_KEY),
    appendChildKey(childKey)
  )(routeKey);

export {
  ROUTE_KEY,
  ROUTES,
  COLD_PAGE_UIDS,
  getRouteKeyForPath,
  getUrlForRouteKey,
  findRouteThatMatch,
  isColdPage,
  getParentOfRouteKey,
  getRouteKeyOfChild,
};
